import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-15b49cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questions-container" }
const _hoisted_2 = { class: "question-primary-language" }
const _hoisted_3 = {
  key: 0,
  class: "question-secondary-language"
}
const _hoisted_4 = { class: "response-container" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-item-container", { 'first-form-item': _ctx.form_item_order === 0 && _ctx.layout_mode === 'all_on_one_page' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.question_lang1), 1),
      (_ctx.bilingue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.question_lang2), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxStars, (star) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "cursor-pointer",
          key: star,
          onClick: ($event: any) => (_ctx.handleClick(star))
        }, [
          (star === 1)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: (_ctx.getCurrentRating) >= star ? _ctx.starOnIcon : _ctx.starOffIcon
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true),
          (star === 2)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: (_ctx.getCurrentRating) >= star ? _ctx.starOnIcon : _ctx.starOffIcon
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true),
          (star === 3)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: (_ctx.getCurrentRating) >= star ? _ctx.starOnIcon : _ctx.starOffIcon
              }, null, 8, _hoisted_8))
            : _createCommentVNode("", true),
          (star === 4)
            ? (_openBlock(), _createElementBlock("img", {
                key: 3,
                src: (_ctx.getCurrentRating) >= star ? _ctx.starOnIcon : _ctx.starOffIcon
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true),
          (star === 5)
            ? (_openBlock(), _createElementBlock("img", {
                key: 4,
                src: (_ctx.getCurrentRating) >= star ? _ctx.starOnIcon : _ctx.starOffIcon
              }, null, 8, _hoisted_10))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, _toDisplayString(_ctx.getDefaultStarLabel(star)), 1)
        ], 8, _hoisted_5))
      }), 128))
    ])
  ], 2))
}